module.exports = __webpack_public_path__ + "static/media/student exclusion records.7cd10c05.svg";